const CarteTarif = ($) => {
  const cta = $(".wp-block-seven-shapes-carte-tarif__link");

  cta
    .mouseenter((e) => {
      const card = $(e.currentTarget).parents(
        ".wp-block-seven-shapes-carte-tarif"
      );
      card.addClass("wp-block-seven-shapes-carte-tarif--isHover");
    })
    .mouseleave((e) => {
      const card = $(e.currentTarget).parents(
        ".wp-block-seven-shapes-carte-tarif"
      );
      card.removeClass("wp-block-seven-shapes-carte-tarif--isHover");
    });
};

export default CarteTarif;
